import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatetimePickerComponent } from './datetime-picker.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    BsDatepickerModule.forRoot(), TimepickerModule.forRoot(),
  ],
  declarations: [DatetimePickerComponent],
  exports:[
    DatetimePickerComponent,
    CommonModule,
    FormsModule, ReactiveFormsModule,
    BsDatepickerModule, 
    TimepickerModule,

  ] 
})
export class DatetimePickerModule { }
